module.exports = __webpack_public_path__ + "static/media/hoover.ed412100.svg";